export default __webpack_public_path__ + "static/media/Trillium-480px-180px.ba389f4e.jpg";